var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-div',{staticStyle:{"margin-bottom":"20px"}},[_c('v-jsoneditor',{staticStyle:{"margin-top":"20px"},attrs:{"options":_vm.jsonOptions,"height":"800px","loading":_vm.loading},model:{value:(_vm.results),callback:function ($$v) {_vm.results=$$v},expression:"results"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }